import React from "react";
import { MousePointer2 } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

// Fin SVG for the toggle button
const FinIcon = ({ className }) => (
  <svg viewBox="0 0 30 30" className={className} fill="currentColor">
    <path d="M4 24 C10 22 18 16 26 5 C24 15 22 22 26 24 C18 25 10 25 4 24 Z" />
  </svg>
);

export default function CursorSwitch() {
  const { cursorStyle, setCursorStyle } = useTheme();

  return (
    <div className="fixed bottom-6 left-6 z-[75] hidden md:flex items-center gap-1 bg-white/90 dark:bg-slate-800/90 backdrop-blur rounded-full p-1.5 border-2 border-teal-200 dark:border-cyan-500/30 shadow-[0_8px_30px_rgba(14,127,168,0.15)]">
      <button
        onClick={() => setCursorStyle("bubble")}
        className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
          cursorStyle === "bubble"
            ? "bg-teal-500 text-white scale-105"
            : "text-slate-500 dark:text-slate-300 hover:bg-teal-50 dark:hover:bg-white/10"
        }`}
        aria-label="Bubble cursor"
        title="Bubble cursor"
      >
        <span className="w-3.5 h-3.5 rounded-full border-2 border-current" />
      </button>
      <button
        onClick={() => setCursorStyle("fin")}
        className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
          cursorStyle === "fin"
            ? "bg-teal-500 text-white scale-105"
            : "text-slate-500 dark:text-slate-300 hover:bg-teal-50 dark:hover:bg-white/10"
        }`}
        aria-label="Shark fin cursor"
        title="Shark fin cursor"
      >
        <FinIcon className="w-4 h-4" />
      </button>
      <button
        onClick={() => setCursorStyle("normal")}
        className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${
          cursorStyle === "normal"
            ? "bg-teal-500 text-white scale-105"
            : "text-slate-500 dark:text-slate-300 hover:bg-teal-50 dark:hover:bg-white/10"
        }`}
        aria-label="Normal cursor"
        title="Normal cursor"
        data-testid="cursor-normal-btn"
      >
        <MousePointer2 className="w-4 h-4" />
      </button>
    </div>
  );
}
